import { Measure } from '../types'
import Big from 'big.js'

enum DataStorageMeasurementSystem {
  bitBased = 'Bit-based Units (1000)',
  bitBasedBinary = 'Bit-based Binary Units (1024)',
  byteBased = 'Byte-based Units (1000)',
  byteBasedBinary = 'Byte-based Binary Units (1024)',
  otherUnits = 'Other Units'
}

const dataStorageUnits = {
  bit: {
    displayName: 'Bit',
    codeName: 'bit',
    url: 'bit',
    symbol: 'b',
    toBaseUnit: (value: Big) => value,
    fromBaseUnit: (value: Big) => value,
    system: DataStorageMeasurementSystem.bitBased
  },
  kilobit: {
    displayName: 'Kilobit',
    codeName: 'kilobit',
    url: 'kilobit',
    symbol: 'Kb',
    toBaseUnit: (value: Big) => value.times(1000),
    fromBaseUnit: (value: Big) => value.div(1000),
    system: DataStorageMeasurementSystem.bitBased
  },
  megabit: {
    displayName: 'Megabit',
    codeName: 'megabit',
    url: 'megabit',
    symbol: 'Mb',
    toBaseUnit: (value: Big) => value.times(1000000),
    fromBaseUnit: (value: Big) => value.div(1000000),
    system: DataStorageMeasurementSystem.bitBased
  },
  gigabit: {
    displayName: 'Gigabit',
    codeName: 'gigabit',
    url: 'gigabit',
    symbol: 'Gb',
    toBaseUnit: (value: Big) => value.times(1000000000),
    fromBaseUnit: (value: Big) => value.div(1000000000),
    system: DataStorageMeasurementSystem.bitBased
  },
  terabit: {
    displayName: 'Terabit',
    codeName: 'terabit',
    url: 'terabit',
    symbol: 'Tb',
    toBaseUnit: (value: Big) => value.times(1000000000000),
    fromBaseUnit: (value: Big) => value.div(1000000000000),
    system: DataStorageMeasurementSystem.bitBased
  },
  petabit: {
    displayName: 'Petabit',
    codeName: 'petabit',
    url: 'petabit',
    symbol: 'Pb',
    toBaseUnit: (value: Big) => value.times(1000000000000000),
    fromBaseUnit: (value: Big) => value.div(1000000000000000),
    system: DataStorageMeasurementSystem.bitBased
  },
  exabit: {
    displayName: 'Exabit',
    codeName: 'exabit',
    url: 'exabit',
    symbol: 'Eb',
    toBaseUnit: (value: Big) => value.times(1000000000000000000),
    fromBaseUnit: (value: Big) => value.div(1000000000000000000),
    system: DataStorageMeasurementSystem.bitBased
  },

  byte: {
    displayName: 'Byte',
    codeName: 'byte',
    url: 'byte',
    symbol: 'B',
    toBaseUnit: (value: Big) => value.times(8),
    fromBaseUnit: (value: Big) => value.div(8),
    system: DataStorageMeasurementSystem.byteBased
  },
  kilobyte: {
    displayName: 'Kilobyte',
    codeName: 'kilobyte',
    url: 'kilobyte',
    symbol: 'KB',
    toBaseUnit: (value: Big) => value.times(8000),
    fromBaseUnit: (value: Big) => value.div(8000),
    system: DataStorageMeasurementSystem.byteBased
  },
  megabyte: {
    displayName: 'Megabyte',
    codeName: 'megabyte',
    url: 'megabyte',
    symbol: 'MB',
    toBaseUnit: (value: Big) => value.times(8000000),
    fromBaseUnit: (value: Big) => value.div(8000000),
    system: DataStorageMeasurementSystem.byteBased
  },
  gigabyte: {
    displayName: 'Gigabyte',
    codeName: 'gigabyte',
    url: 'gigabyte',
    symbol: 'GB',
    toBaseUnit: (value: Big) => value.times(8000000000),
    fromBaseUnit: (value: Big) => value.div(8000000000),
    system: DataStorageMeasurementSystem.byteBased
  },
  terabyte: {
    displayName: 'Terabyte',
    codeName: 'terabyte',
    url: 'terabyte',
    symbol: 'TB',
    toBaseUnit: (value: Big) => value.times(8000000000000),
    fromBaseUnit: (value: Big) => value.div(8000000000000),
    system: DataStorageMeasurementSystem.byteBased
  },
  petabyte: {
    displayName: 'Petabyte',
    codeName: 'petabyte',
    url: 'petabyte',
    symbol: 'PB',
    toBaseUnit: (value: Big) => value.times(8000000000000000),
    fromBaseUnit: (value: Big) => value.div(8000000000000000),
    system: DataStorageMeasurementSystem.byteBased
  },
  exabyte: {
    displayName: 'Exabyte',
    codeName: 'exabyte',
    url: 'exabyte',
    symbol: 'EB',
    toBaseUnit: (value: Big) => value.times(8000000000000000000),
    fromBaseUnit: (value: Big) => value.div(8000000000000000000),
    system: DataStorageMeasurementSystem.byteBased
  },


  kibibit: {
    displayName: 'Kibibit',
    codeName: 'kibibit',
    url: 'kibibit',
    symbol: 'Kib',
    toBaseUnit: (value: Big) => value.times(1024),
    fromBaseUnit: (value: Big) => value.div(1024),
    system: DataStorageMeasurementSystem.bitBasedBinary
  },
  mebibit: {
    displayName: 'Mebibit',
    codeName: 'mebibit',
    url: 'mebibit',
    symbol: 'Mib',
    toBaseUnit: (value: Big) => value.times(1048576),
    fromBaseUnit: (value: Big) => value.div(1048576),
    system: DataStorageMeasurementSystem.bitBasedBinary
  },
  gibibit: {
    displayName: 'Gibibit',
    codeName: 'gibibit',
    url: 'gibibit',
    symbol: 'Gib',
    toBaseUnit: (value: Big) => value.times(1073741824),
    fromBaseUnit: (value: Big) => value.div(1073741824),
    system: DataStorageMeasurementSystem.bitBasedBinary
  },
  tebibit: {
    displayName: 'Tebibit',
    codeName: 'tebibit',
    url: 'tebibit',
    symbol: 'Tib',
    toBaseUnit: (value: Big) => value.times(1099511627776),
    fromBaseUnit: (value: Big) => value.div(1099511627776),
    system: DataStorageMeasurementSystem.bitBasedBinary
  },
  pebibit: {
    displayName: 'Pebibit',
    codeName: 'pebibit',
    url: 'pebibit',
    symbol: 'Pib',
    toBaseUnit: (value: Big) => value.times(1125899906842624),
    fromBaseUnit: (value: Big) => value.div(1125899906842624),
    system: DataStorageMeasurementSystem.bitBasedBinary
  },
  exbibit: {
    displayName: 'Exbibit',
    codeName: 'exbibit',
    url: 'exbibit',
    symbol: 'Eib',
    toBaseUnit: (value: Big) => value.times(1152921504606846976),
    fromBaseUnit: (value: Big) => value.div(1152921504606846976),
    system: DataStorageMeasurementSystem.bitBasedBinary
  },

  kibibyte: {
    displayName: 'Kibibyte',
    codeName: 'kibibyte',
    url: 'kibibyte',
    symbol: 'KiB',
    toBaseUnit: (value: Big) => value.times(8192),
    fromBaseUnit: (value: Big) => value.div(8192),
    system: DataStorageMeasurementSystem.byteBasedBinary
  },
  mebibyte: {
    displayName: 'Mebibyte',
    codeName: 'mebibyte',
    url: 'mebibyte',
    symbol: 'MiB',
    toBaseUnit: (value: Big) => value.times(8388608),
    fromBaseUnit: (value: Big) => value.div(8388608),
    system: DataStorageMeasurementSystem.byteBasedBinary
  },
  gibibyte: {
    displayName: 'Gibibyte',
    codeName: 'gibibyte',
    url: 'gibibyte',
    symbol: 'GiB',
    toBaseUnit: (value: Big) => value.times(8589934592),
    fromBaseUnit: (value: Big) => value.div(8589934592),
    system: DataStorageMeasurementSystem.byteBasedBinary
  },
  tebibyte: {
    displayName: 'Tebibyte',
    codeName: 'tebibyte',
    url: 'tebibyte',
    symbol: 'TiB',
    toBaseUnit: (value: Big) => value.times(8796093022208),
    fromBaseUnit: (value: Big) => value.div(8796093022208),
    system: DataStorageMeasurementSystem.byteBasedBinary
  },
  pebibyte: {
    displayName: 'Pebibyte',
    codeName: 'pebibyte',
    url: 'pebibyte',
    symbol: 'PiB',
    toBaseUnit: (value: Big) => value.times(9007199254740992),
    fromBaseUnit: (value: Big) => value.div(9007199254740992),
    system: DataStorageMeasurementSystem.byteBasedBinary
  },
  exbibyte: {
    displayName: 'Exbibyte',
    codeName: 'exbibyte',
    url: 'exbibyte',
    symbol: 'EiB',
    toBaseUnit: (value: Big) => value.times(9223372036854775808),
    fromBaseUnit: (value: Big) => value.div(9223372036854775808),
    system: DataStorageMeasurementSystem.byteBasedBinary
  },

  block: {
    displayName: 'Block',
    codeName: 'block',
    url: 'block',
    symbol: 'blk',
    toBaseUnit: (value: Big) => value,
    fromBaseUnit: (value: Big) => value,
    system: DataStorageMeasurementSystem.otherUnits
  },
  nibble: {
    displayName: 'Nibble',
    codeName: 'nibble',
    url: 'nibble',
    symbol: 'nib',
    toBaseUnit: (value: Big) => value.times(4),
    fromBaseUnit: (value: Big) => value.div(4),
    system: DataStorageMeasurementSystem.otherUnits
  },
  word: {
    displayName: 'Word',
    codeName: 'word',
    url: 'word',
    symbol: 'w',
    toBaseUnit: (value: Big) => value.times(16),
    fromBaseUnit: (value: Big) => value.div(16),
    system: DataStorageMeasurementSystem.otherUnits
  }
}


export const dataStorage: Measure = {
  displayName: 'Data storage',
  codeName: 'dataStorage',
  url: 'data-storage',
  units: dataStorageUnits,
  baseUnit: dataStorageUnits.bit,
  defaultFromUnit: dataStorageUnits.megabyte,
  defaultToUnit: dataStorageUnits.kilobyte
}
